var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "spnod-admin__form--main d-flex align-items-center flex-column",
    attrs: {
      "id": "verify-main"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Resend Code")]), _vm._v(" "), _c('ResendCodeForm')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ed93c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AdminAuth/ResendCode.vue
// module id = Rv7z
// module chunks = 2